import { type SliceWallState } from "@package/ui-wall-engine";
import { type ThunkDispatch, type UnknownAction } from "@reduxjs/toolkit";
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";

type ReduxState = {
  wall: SliceWallState;
};
type ReduxDispatch = ThunkDispatch<ReduxState, undefined, UnknownAction>;

export const useDispatchWall: () => ReduxDispatch = useDispatch;
export const useSelectorWall: TypedUseSelectorHook<ReduxState> = useSelector;
